/**
 * User Roles/Types
 *
 * Defines the available user types in the CloudSpry application.
 * These correspond to the user_type field returned by the API.
 */

export const ROLES = {
  /** Main account owner with full control over everything */
  SUPER_ADMIN: "superadmin",
  /** Administrative user with management access */
  ADMIN: "admin",
  /** Team member with limited, permission-based access */
  MEMBER: "member",
} as const

export type Role = (typeof ROLES)[keyof typeof ROLES]

/**
 * Check if a role is an administrative role (superadmin or admin)
 */
export const isAdminRole = (role: Role): boolean => {
  return role === ROLES.SUPER_ADMIN || role === ROLES.ADMIN
}

/**
 * Check if a role is a member role
 */
export const isMemberRole = (role: Role): boolean => {
  return role === ROLES.MEMBER
}

/**
 * Get display name for a role
 */
export const getRoleDisplayName = (role: Role): string => {
  const displayNames: Record<Role, string> = {
    [ROLES.SUPER_ADMIN]: "Super Admin",
    [ROLES.ADMIN]: "Admin",
    [ROLES.MEMBER]: "Member",
  }
  return displayNames[role] || role
}
